import { BaseService } from '../../infra/base.service'
import type { ImportScheduleDto } from './dto/import-schedule.dto'
import type { Schedule } from './schedule'
import type { SchedulesRepository } from './schedules.repository'

export class SchedulesService extends BaseService<Schedule> {
    constructor(private rep: SchedulesRepository) {
        super(rep)
    }

    async importSchedules(dto: ImportScheduleDto[]) {
        return await this.rep.importSchedules(dto)
    }

    async changed(from: Date) {
        return await this.rep.changed(from)
    }

    async changeStatus(scheduleId: string, status: number) {
        return await this.rep.changeStatus(scheduleId, status)
    }

    async hollidays(year: number) {
        return await this.rep.hollidays(year)
    }
}
